import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import BookingDetails from "../../Components/Booking/bookingDetails";

import Header from "../../Components/Header/Header";
import CustomPagination from "../../Components/CustomPagination/CustomPagination";
import EmptyData from "../../Components/EmptyData/EmptyData";

import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";

import { apiCallGetAllBookingList, apiCallGetTicketDetails } from "../../Core/Apicall";

import Icons from "../../Constants/Icons";

import "./bookedEvent.css";

function BookedEvents() {

  const dispatch = useDispatch();

  const isLoading = useSelector(
    (state) => state.isLoading
  );

  const [bookingList, setBookingList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [initialPage, setInitialPage] = useState(0);
  const [openBookingDetails, setOpenBookingDetails] = useState(false);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [search, setSearch] = useState("");
  const [bookingStatus, setBookingStatus] = useState("");
  const [dayFilter, setDayFilter] = useState("today");



  // ==================================================
  // GET BOOKING DETAILS
  // ==================================================

  const fetchBookingDetails = async (bookingId) => {
    try {
      dispatch(setLoadingTrue());
      const body = {
        bookingId: bookingId,
      };
      const response = await apiCallGetTicketDetails(body);

      if (response?.status) {
        setBookingDetails(response?.data);
        setOpenBookingDetails(true);
      }

    } catch (error) {
      console.log("Booking Details Error : ", error);

    } finally {

      dispatch(setLoadingFalse());

    }
  };

  // ==================================================
  // GET BOOKING LIST
  // ==================================================

  const fetchBookingList = async (
    selectedPage = 0
  ) => {

    try {

      dispatch(setLoadingTrue());

      const limit = 10;

      const body = {
        dayFilter: dayFilter,
        bookingStatus: bookingStatus,
        search: search,
        offset: selectedPage * limit,
        limit: limit,
      };

      const response =
        await apiCallGetAllBookingList(body);

      setBookingList(response?.data || []);
      setPagination(response?.pagination || {});
      setInitialPage(selectedPage);

    } catch (error) {

      console.log(
        "Booking List Error : ",
        error
      );

    } finally {

      dispatch(setLoadingFalse());

    }
  };

  // ==================================================
  // USE EFFECT
  // ==================================================

  useEffect(() => {

    fetchBookingList(0);

  }, [search, bookingStatus, dayFilter]);

  // ==================================================
  // STATUS STYLE
  // ==================================================

  const getStatusStyle = (status) => {

    switch (status) {

      case "Booked":
        return {
          background: "rgba(0,168,255,0.15)",
          color: "#00A8FF",
        };

      case "Confirmed":
        return {
          background: "rgba(46,204,113,0.15)",
          color: "#2ECC71",
        };

      case "Pending":
        return {
          background: "rgba(241,196,15,0.15)",
          color: "#F1C40F",
        };

      case "Cancelled":
        return {
          background: "rgba(231,76,60,0.15)",
          color: "#E74C3C",
        };

      default:
        return {
          background: "rgba(255,255,255,0.1)",
          color: "#FFFFFF",
        };
    }
  };

  return (
    <div>

      <Header name={"Booked Events"} />

      <div className="Event-custom-style">

        <div className="lastWeekEndDiv Event-AlignSelf-stretch">

          {/* ================================================= */}
          {/* HEADER */}
          {/* ================================================= */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >

            <div className="user_title">
              Booked Tickets
            </div>

            {/* FILTERS */}

            {/* FILTERS */}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "12px",
                flexWrap: "wrap",
                width: "100%",
              }}
            >

              {/* SEARCH */}

              <div
                style={{
                  position: "relative",
                  width: "280px",
                }}
              >

                <input
                  type="text"
                  placeholder="Search"
                  value={search}
                  onChange={(e) =>
                    setSearch(e.target.value)
                  }
                  style={{
                    width: "100%",
                    height: "44px",
                    background: "#001B44",
                    border: "1px solid #0EA5FF",
                    borderRadius: "10px",
                    padding: "0px 45px 0px 16px",
                    color: "#FFFFFF",
                    fontSize: "14px",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />

                <img
                  src={Icons.ic_search}
                  alt=""
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "18px",
                    height: "18px",
                    objectFit: "contain",
                  }}
                />

              </div>

              {/* DAY FILTER */}

              <select
                value={dayFilter}
                onChange={(e) =>
                  setDayFilter(e.target.value)
                }
                style={{
                  width: "150px",
                  height: "44px",
                  background: "#001B44",
                  border: "1px solid #00A8FF",
                  borderRadius: "10px",
                  padding: "0px 15px",
                  color: "#FFFFFF",
                  fontSize: "14px",
                  outline: "none",
                  cursor: "pointer",
                  boxSizing: "border-box",
                }}
              >

                <option value="today">
                  Today
                </option>

                <option value="lastday">
                  Last Day
                </option>

                <option value="lastweek">
                  Last Week
                </option>

                <option value="thismonth">
                  This Month
                </option>

                <option value="thisyear">
                  This Year
                </option>

              </select>

              {/* STATUS FILTER */}

              <select
                value={bookingStatus}
                onChange={(e) =>
                  setBookingStatus(e.target.value)
                }
                style={{
                  width: "150px",
                  height: "44px",
                  background: "#001B44",
                  border: "1px solid #FF2E93",
                  borderRadius: "10px",
                  padding: "0px 15px",
                  color: "#FFFFFF",
                  fontSize: "14px",
                  outline: "none",
                  cursor: "pointer",
                  boxSizing: "border-box",
                }}
              >

                <option value="">
                  All Status
                </option>

                <option value="Pending">
                  Pending
                </option>

                <option value="Confirmed">
                  Confirmed
                </option>

                <option value="Cancelled">
                  Cancelled
                </option>

                <option value="Booked">
                  Booked
                </option>

              </select>

            </div>

          </div>

          {/* ================================================= */}
          {/* TABLE */}
          {/* ================================================= */}

          <div className="transparentWhite">

            {/* TABLE HEADER */}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "18px 20px",
                borderBottom:
                  "1px solid rgba(255,255,255,0.08)",
                background:
                  "rgba(255,255,255,0.03)",
                borderRadius:
                  "12px 12px 0px 0px",
              }}
            >

              <div
                className="user_name"
                style={{ width: "28%" }}
              >
                User
              </div>

              <div
                className="user_name"
                style={{
                  width: "10%",
                  textAlign: "center",
                }}
              >
                Seat
              </div>

              <div
                className="user_name"
                style={{
                  width: "8%",
                  textAlign: "center",
                }}
              >
                Qty
              </div>

              <div
                className="user_name"
                style={{
                  width: "10%",
                  textAlign: "center",
                }}
              >
                Price
              </div>

              <div
                className="user_name"
                style={{
                  width: "12%",
                  textAlign: "center",
                }}
              >
                Amount
              </div>

              <div
                className="user_name"
                style={{
                  width: "14%",
                  textAlign: "center",
                }}
              >
                Payment
              </div>

              <div
                className="user_name"
                style={{
                  width: "14%",
                  textAlign: "center",
                }}
              >
                Booking
              </div>

              <div
                className="user_name"
                style={{
                  width: "14%",
                  textAlign: "center",
                }}
              >
                Date
              </div>

            </div>

            {/* TABLE BODY */}

            <div className="scrollable-container h-max-450">

              {
                bookingList?.length === 0 &&
                  !isLoading ? (

                  <EmptyData />

                ) : (

                  bookingList?.map(
                    (item, index) => {

                      return (

                        <div
                          key={index}
                          onClick={() =>
                            fetchBookingDetails(item?._id)
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "16px 20px",
                            borderBottom:
                              "1px solid rgba(255,255,255,0.08)",
                            cursor: "pointer",
                            transition: "0.3s",
                          }}
                        >

                          {/* USER */}

                          <div
                            style={{
                              width: "28%",
                              display: "flex",
                              alignItems:
                                "center",
                              gap: "12px",
                            }}
                          >

                            <img
                              src={
                                item?.userData
                                  ?.profileImageURL
                              }
                              alt=""
                              style={{
                                width: "45px",
                                height: "45px",
                                borderRadius:
                                  "50%",
                                objectFit:
                                  "cover",
                              }}
                            />

                            <div
                              style={{
                                overflow:
                                  "hidden",
                              }}
                            >

                              <div
                                style={{
                                  color:
                                    "#FFFFFF",
                                  fontWeight:
                                    "600",
                                  whiteSpace:
                                    "nowrap",
                                  overflow:
                                    "hidden",
                                  textOverflow:
                                    "ellipsis",
                                }}
                              >
                                {
                                  item?.userData
                                    ?.name
                                }
                              </div>

                              <div
                                style={{
                                  color:
                                    "rgba(255,255,255,0.6)",
                                  fontSize:
                                    "13px",
                                  marginTop:
                                    "3px",
                                }}
                              >
                                @
                                {
                                  item?.userData
                                    ?.userName
                                }
                              </div>

                            </div>

                          </div>

                          {/* SEAT */}

                          <div
                            style={{
                              width: "10%",
                              textAlign:
                                "center",
                              color:
                                "#FFFFFF",
                            }}
                          >
                            {
                              item?.bookedSeatsType
                            }
                          </div>

                          {/* QTY */}

                          <div
                            style={{
                              width: "8%",
                              textAlign:
                                "center",
                              color:
                                "#FFFFFF",
                            }}
                          >
                            {item?.quantity}
                          </div>

                          {/* PRICE */}

                          <div
                            style={{
                              width: "10%",
                              textAlign:
                                "center",
                              color:
                                "#FFFFFF",
                            }}
                          >
                            ₹
                            {item?.ticketPrice}
                          </div>

                          {/* AMOUNT */}

                          <div
                            style={{
                              width: "12%",
                              textAlign:
                                "center",
                              color:
                                "#00ff9d",
                              fontWeight:
                                "700",
                            }}
                          >
                            ₹
                            {item?.totalAmount}
                          </div>

                          {/* PAYMENT STATUS */}

                          <div
                            style={{
                              width: "14%",
                              display: "flex",
                              justifyContent:
                                "center",
                            }}
                          >

                            <div
                              style={{
                                minWidth:
                                  "100px",
                                height: "34px",
                                borderRadius:
                                  "30px",
                                display:
                                  "flex",
                                alignItems:
                                  "center",
                                justifyContent:
                                  "center",
                                fontSize:
                                  "13px",
                                fontWeight:
                                  "600",

                                background:
                                  item?.paymentStatus ===
                                    "Success"
                                    ? "rgba(46,204,113,0.15)"
                                    : "rgba(231,76,60,0.15)",

                                color:
                                  item?.paymentStatus ===
                                    "Success"
                                    ? "#2ECC71"
                                    : "#E74C3C",
                              }}
                            >
                              {
                                item?.paymentStatus
                              }
                            </div>

                          </div>

                          {/* BOOKING STATUS */}

                          <div
                            style={{
                              width: "14%",
                              display: "flex",
                              justifyContent:
                                "center",
                            }}
                          >

                            <div
                              style={{
                                minWidth:
                                  "100px",
                                height: "34px",
                                borderRadius:
                                  "30px",
                                display:
                                  "flex",
                                alignItems:
                                  "center",
                                justifyContent:
                                  "center",
                                fontSize:
                                  "13px",
                                fontWeight:
                                  "600",
                                ...getStatusStyle(
                                  item?.bookingStatus
                                ),
                              }}
                            >
                              {
                                item?.bookingStatus
                              }
                            </div>

                          </div>

                          {/* DATE */}

                          <div
                            style={{
                              width: "14%",
                              textAlign:
                                "center",
                              color:
                                "#FFFFFF",
                            }}
                          >
                            {moment(
                              item?.createdAt
                            ).format(
                              "DD MMM YYYY"
                            )}
                          </div>

                        </div>
                      );
                    }
                  )
                )
              }

            </div>

          </div>

          {
            openBookingDetails && (

              <BookingDetails
                bookingDetails={bookingDetails}
                onClose={() => {
                  setOpenBookingDetails(false);
                  setBookingDetails(null);
                }}
              />

            )
          }

        </div>


      </div>
      {/* ================================================= */}
      {/* PAGINATION */}
      {/* ================================================= */}

      {
        bookingList?.length > 0 && (

          <div
            className="Custom-Pagination"
            style={{
              marginTop: "20px",
            }}
          >

            <CustomPagination
              pageCount={
                pagination?.pages || 1
              }
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              initialPage={initialPage}
              forcePage={initialPage}
              onPageChange={({
                selected,
              }) => {

                fetchBookingList(
                  selected
                );

              }}
            />

          </div>
        )
      }

    </div>
  );
}

export default BookedEvents;